import { createAsyncThunk } from '@reduxjs/toolkit';

export const SetIfFirstVisit = createAsyncThunk(
    'clubhouse/setIfFirstVisit',
    async (_args, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.post(`/api/clubhouses/pocprofile/add-to-viewed`);
        return response;
    }
);